import React, { useState, useContext, useEffect, useRef, useCallback } from "react";
import { NavLink } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import PurchaseOrderPrint from "./PurchaseOrderPrint";

//pages & includes
import ManageSidebar from "../ManageSidebar";

//functions
import {
    _t,
    getCookie,
    formatPrice,
    currencySymbolLeft,
    currencySymbolRight,
    checkPermission
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";
import { MdDelete } from 'react-icons/md';
import { FaCheckCircle } from "react-icons/fa";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//3rd party packages
import { Helmet } from "react-helmet";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { ToastError, ToastSuccess } from "../../../../../functions/ToastShow";
import Moment from "react-moment";

//context consumer
import { RestaurantContext } from "../../../../../contexts/Restaurant";
import { UserContext } from "../../../../../contexts/User";
import DataTable from "../../../../common/DataTable";
import CsvImportExport from "../../../../../components/CsvImportExport";
import { BiRefresh } from "react-icons/bi";

const PurchaseRequestHistory = () => {
    const { t } = useTranslation();

    let {
        //common
        loading,

        //purchase request
        getPaginatedPurchaseRequest,
        setPurchaseRequestList,
        setPurchaseRequestListForSearch,
        purchaseRequestListForSearch,
        purchaseRequestList,
        branchForListSearch,

        //pagination
        dataPaginating,
        setDataPaginating,
    } = useContext(RestaurantContext);

    let { getSupplier, authUserInfo, supplierForSearch } = useContext(UserContext);

    //search result
    let [searchedPurchaseReq, setSearchedPurchaseReq] = useState({
        list: null,
        searched: false,
    });

    const [btnDisable, setBtnDisable] = useState("");

    const searchInputRef = useRef(null);

    //useEffect == componentDidMount
    useEffect(() => {
        getPaginatedPurchaseRequest(1);

        if (!supplierForSearch) {
            getSupplier();
        }
    }, []);
    //search purchase order here
    const handleSearch = (e) => {
        let searchInput = e.target.value.toLowerCase();
        if (searchInput.length === 0) {
            setSearchedPurchaseReq({ ...searchedPurchaseReq, searched: false });
        } else {
            let searchedList = purchaseRequestListForSearch.filter((item) => {
                //name
                //let lowerCaseItemSupplierName = item.supplier_name && item.supplier_name.toLowerCase();
                //branch
                let lowerCaseBranch = item?.branch_name && item.branch_name.toLowerCase();
                //email
                let lowerCaseItemInvoice =
                    item.document_identity && item.document_identity.toLowerCase();

                return (
                    // (lowerCaseItemSupplierName && lowerCaseItemSupplierName.includes(searchInput)) ||
                    lowerCaseItemInvoice.includes(searchInput) ||
                    lowerCaseBranch.includes(searchInput)
                );
            });
            setSearchedPurchaseReq({
                ...searchedPurchaseReq,
                list: searchedList,
                searched: true,
            });
        }
    };

    //delete confirmation modal of purchase order
    const handleDeleteConfirmation = (id) => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className="card card-body">
                        <h1>{_t(t("Are you sure?"))}</h1>
                        <p className="text-center">{_t(t("You want to delete this?"))}</p>
                        <div className="d-flex justify-content-center">
                            <button
                                className="btn btn-primary"
                                onClick={() => {
                                    handleDeletePurchase(id);
                                    onClose();
                                }}
                            >
                                {_t(t("Yes, delete it!"))}
                            </button>
                            <button className="btn btn-success ml-2 px-3" onClick={onClose}>
                                {_t(t("No"))}
                            </button>
                        </div>
                    </div>
                );
            },
        });
    };

    const handleSetCsvResponse = useCallback((data) => {
        setPurchaseRequestList(data[0]);
        setPurchaseRequestListForSearch(data[1]);
        setSearchedPurchaseReq({
            ...searchedPurchaseReq,
            list: data[1],
        });
    }, [])

    //delete purchase here
    const handleDeletePurchase = (id) => {
        setDataPaginating(true);
        const url = BASE_URL + `/settings/purchase-request/${id}`;
        return axios
            .delete(url, {
                headers: { Authorization: `Bearer ${getCookie()}` },
            })
            .then((res) => {
                handleSetCsvResponse(res.data)
                setDataPaginating(false);
                ToastSuccess({ title: `${_t(t("Purchase Request has been deleted"))}` });
            }).catch(() => {
                setDataPaginating(false);
                ToastError({ title: `${_t(t("Please try again"))}` });
            });
    };

    //post pr
    const handlePostApi = (id) => {
        // setDataPaginating(true);
        setBtnDisable(id)
        const url = BASE_URL + `/settings/mark-is-post-pr`;
        const formData = {
            id: id,
            status: 1
        }
        return axios
            .post(url, formData, {
                headers: { Authorization: `Bearer ${getCookie()}` },
            })
            .then((res) => {
                handleSetCsvResponse(res.data);
                setBtnDisable("");
                setDataPaginating(false);
                ToastSuccess({ title: `${_t(t("Purchase has been post"))}` });
            }).catch((error) => {
                setDataPaginating(false);
                setBtnDisable("");
                if(error.response?.data?.message){
                    ToastError({ title: `${_t(t(error.response.data.message))}` });
                    return
                }
                ToastError({ title: `${_t(t("Please try again"))}` });
            });
    }

    //pr approve
    const handleApprove = (id) => {
        // setDataPaginating(true);
        setBtnDisable(id)
        const url = BASE_URL + `/settings/update-pr-status/${id}`;
        return axios
            .get(url, {
                headers: { Authorization: `Bearer ${getCookie()}` },
            })
            .then((res) => {
                handleSetCsvResponse(res.data);
                setBtnDisable("")
                setDataPaginating(false);
                ToastSuccess({ title: `${_t(t("PR has been approve"))}` });
            }).catch((error) => {
                setDataPaginating(false);
                setBtnDisable("");
                if(error.response?.data?.message){
                    ToastError({ title: `${_t(t(error.response.data.message))}` });
                    return
                }
                ToastError({ title: `${_t(t("Please try again"))}` });
            });
    }

    //print bills states and function
    const [newRow, setNewRow] = useState([]);
    let [puchaseReqView, setPuchaseReqView] = useState({
        date: null,
        doc_id: null,
        supplier: null,
        branch: '',
        remarks: '',
        total_amount: ''
    });

    const componentRef = useRef();

    const handleOnlyPrint = useReactToPrint({
        content: () => componentRef.current,
        pageStyle: "@page { margin: 15px }"
    });

    const handleGetPrintData = async (id) => {
        const url = BASE_URL + "/settings/purchase-request/" + parseInt(id);
        // setDataPaginating(true)
        try {
            const res = await axios
                .get(url, {
                    headers: { Authorization: `Bearer ${getCookie()}` },
                });
            if (res.data && res.data.purchase_request_detail) {
                let purchaseDate = new Date(res.data.document_date);
                let suplier = supplierForSearch?.find(item => item?.id === res.data.supplier_id);
                const branch = branchForListSearch[res.data.branch_id]
                setPuchaseReqView({
                    ...puchaseReqView,
                    date: purchaseDate,
                    branch,
                    supplier: suplier,
                    doc_id: res.data.document_identity,
                    remarks: res.data.remarks,
                    total_amount: res.data.total_amount
                })
                setNewRow([...res.data.purchase_request_detail]);
                setDataPaginating(false)
                setTimeout(() => {
                    handleOnlyPrint();
                }, 0);
            }
        } catch (error) {
            setDataPaginating(false)
            console.log("error==>", error)
            ToastError({ title: `${_t(t("Please try again"))}` });
        }
    }

    const handleClosingPr = async (id) => {
        const url = BASE_URL + "/settings/close-purchase-request/" + parseInt(id);
        // setDataPaginating(true)
        setBtnDisable(id)
        try {
            const res = await axios
                .post(url, null, {
                    headers: { Authorization: `Bearer ${getCookie()}` },
                });
            if (res.data) {
                handleSetCsvResponse(res.data);
                setBtnDisable("")
                setDataPaginating(false);
                ToastSuccess({ title: `${_t(t("PR has been close"))}` });
            }
        } catch (error) {
            setDataPaginating(false);
            setBtnDisable("")
            if(error.response?.data?.message){
                ToastError({ title: `${_t(t(error.response.data.message))}` });
                return
            }
            ToastError({ title: `${_t(t("Please try again"))}` });
        }
    }

    const COLUMNS = [
        { label: "S/L", render: (item, i) => i + 1 },
        { label: "PR #", key: "document_identity" },
        { label: "PO Date", render: (item) => <Moment format="LL">{item.document_date}</Moment> },
        { label: "Branch", key: "branch_name" },
        {
            label: "Total", render: (item) => (
                <>
                    {currencySymbolLeft()}
                    {formatPrice(item.total_amount)}
                    {currencySymbolRight()}
                </>
            )
        },
        {
            label: "Status", render: (item) => (
                item.status === "Open" ? <span className="text-success">{item.status}</span> : (item.status === "Closed" ? <span className="text-danger">{item.status}</span> : <>{item.status}</>)
            )
        },
        {
            label: "Action", render: (item) => (
                <div className="d-flex justify-content-center">
                    <button
                        className="btn btn-secondary ml-2 rounded-sm del-btn"
                        onClick={() => handleGetPrintData(item.id)}
                    >
                        <i className="fa fa-print edit-icon"></i>
                    </button>
                    {item.status !== "Pending" ? <NavLink
                        title="Duplicate Purchase Request"
                        to={`/dashboard/manage/stock/purchase-request-edit/${item.id}?duplicate=1`}
                        className="btn btn-success ml-2 rounded-sm del-btn"
                    >
                        <i className="fa fa-clone"></i>
                    </NavLink> : null}
                    {item.is_post && item.status === "Open" && checkPermission(authUserInfo.permissions, "PR Close") ? (
                        <button
                            title="Pr Close"
                            disabled={item.id === btnDisable}
                            className="btn btn-warning ml-2 rounded-sm del-btn"
                            onClick={() => handleClosingPr(item.id)}
                        >
                            <BiRefresh className="del-icon" />
                        </button>
                    ) : ""
                    }
                    {
                        item.is_post !== 1 ?
                            <>
                                {
                                    item.status === "Pending" && (
                                        <NavLink
                                            disabled={item.id === btnDisable}
                                            className="btn btn-primary ml-2 rounded-sm"
                                            to={`/dashboard/manage/stock/purchase-request-edit/${item.id}`}
                                            style={{ height: "1.7rem", width: "1.7rem" }}
                                        >
                                            <div className="d-flex align-items-center justify-content-center">
                                                <i className="fa fa-pencil edit-icon" aria-hidden="true"></i>
                                            </div>
                                        </NavLink>
                                    )
                                }
                                <button
                                    disabled={item.id === btnDisable}
                                    className="btn btn-danger ml-2 rounded-sm del-btn"
                                    onClick={() => handleDeleteConfirmation(item.id)}
                                >
                                    <MdDelete className="del-icon" />
                                </button>
                                {
                                    item.status === "Pending" ? (checkPermission(authUserInfo.permissions, "MS PR Approve") &&
                                        <button
                                            title="Approve"
                                            disabled={item.id === btnDisable}
                                            className="btn btn-warning ml-2 rounded-sm del-btn"
                                            onClick={() => handleApprove(item.id)}
                                        >
                                            <FaCheckCircle className="del-icon" />
                                        </button>
                                    ) : (
                                        checkPermission(authUserInfo.permissions, "MS PR Post") && (
                                            <button
                                                className="btn btn-dark ml-2 rounded-sm del-btn"
                                                title="Post purchase"
                                                disabled={loading || item.id === btnDisable}
                                                style={{ padding: "1px 0px 0px 1px" }}
                                                onClick={() => handlePostApi(item.id)}
                                            >
                                                <i className="fa fa-check-square-o" aria-hidden="true"></i>
                                            </button>
                                        )
                                    )
                                }
                            </>
                            : ""
                    }
                </div>
            )
        },
        { label: "Remarks", key: "remarks" },
        { label: "Created By", render: (item) => <>{item?.created_by_name || "-"}</> },
        { label: "Updated By", render: (item) => <>{item?.updated_by_name || "-"}</> },
        { label: "Posted By", render: (item) => <>{item?.post_by_name || "-"}</> },
    ]

    const getListData = useCallback(() => {
        if (searchedPurchaseReq.searched) {
            return searchedPurchaseReq.list;
        }
        return purchaseRequestList?.data || [];
    }, [searchedPurchaseReq, purchaseRequestList]);

    const handleFetchData = (page) => {
        getPaginatedPurchaseRequest(page);
    }

    const onClearSearch = () => {
        setSearchedPurchaseReq({ ...searchedPurchaseReq, searched: false });
        if (searchInputRef.current) {
            searchInputRef.current.value = "";
        }
    }

    const csvData = [
        {
            key: "id",
            index: 0,
        },
        {
            key: "branch_name",
            index: 1,
        },
        {
            key: "remarks",
            index: 2,
        },
        {
            key: "item_name",
            index: 3,
        },
        {
            key: "unit_name",
            index: 4,
        },
        {
            key: "qty",
            index: 5,
        },
        // {
        //   key:"base_unit",
        //   index: 8,
        // },
        // {
        //   key:"base_qty",
        //   index: 9,
        // },
        // {
        //   key:"conversion_qty",
        //   index: 10,
        // },
    ]

    return (
        <>
            <Helmet>
                <title>{_t(t("Purchases Request"))}</title>
            </Helmet>

            {/* main body */}
            <main id="main" data-simplebar>
                <div className="container-fluid">
                    <div className="row t-mt-10 gx-2">
                        {/* left Sidebar */}
                        <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
                            <ManageSidebar />
                        </div>
                        {/* left Sidebar ends */}

                        {/* Rightbar contents */}
                        <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
                            <div key="fragment3">
                                {/* next page data spin loading */}
                                {/* <CustomSpinLoader loading={loading || dataPaginating} /> */}
                                {/* spin loading ends */}
                                <div className="t-bg-white">
                                    <div className=" row mx-3 gx-2 align-items-center t-pt-15 t-pb-15">
                                        <div className="col-md-7 col-lg-6 t-mb-15 mb-md-0 d-flex justify-content-between align-items-center">
                                            <ul className="t-list fk-breadcrumb">
                                                <li className="fk-breadcrumb__list">
                                                    <span className="t-link fk-breadcrumb__link text-capitalize">
                                                        {t("Purchases Request List")}
                                                    </span>
                                                </li>
                                            </ul>
                                            <CsvImportExport
                                                filename="PR Sample Format CSV"
                                                csvLength={6}
                                                exportUrl="/settings/export-purchase-request-csv"
                                                importUrl="/settings/upload-purchase-request-csv"
                                                exportBtnName="Sample Format CSV"
                                                csvData={csvData}
                                                onCsvResponse={handleSetCsvResponse}
                                            />
                                        </div>
                                        <div className="col-md-5 col-lg-6">
                                            <div className="row gx-3 align-items-center">
                                                {/* Search customer */}
                                                <div className="col-md-9 t-mb-15 mb-md-0">
                                                    <div className="input-group">
                                                        <div className="form-file">
                                                            <input
                                                                ref={searchInputRef}
                                                                type="text"
                                                                className="form-control border-0 form-control--light-1 rounded-left"
                                                                placeholder={_t(t("Search")) + ".."}
                                                                onChange={handleSearch}
                                                                disabled={loading || dataPaginating}
                                                            />
                                                        </div>
                                                        <button
                                                            className="btn btn-primary rounded-right"
                                                            type="button"
                                                        >
                                                            <i
                                                                className="fa fa-search"
                                                                aria-hidden="true"
                                                            ></i>
                                                        </button>
                                                    </div>
                                                </div>

                                                {/* Add customer modal trigger button */}
                                                <div className="col-md-3 text-md-right">
                                                    <NavLink
                                                        to="/dashboard/manage/stock/purchase-request-add"
                                                        className="btn btn-primary xsm-text text-uppercase btn-lg btn-block rounded"
                                                    >
                                                        {_t(t("add new"))}
                                                    </NavLink>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* Table */}
                                <DataTable
                                    loading={loading || dataPaginating}
                                    data={getListData()}
                                    columns={COLUMNS}
                                    emptyText="No data available"
                                    pagination={{
                                        isPageLoading: loading,
                                        isPagination: true,
                                        pageCount: purchaseRequestList?.last_page,
                                        currentPage: purchaseRequestList?.current_page,
                                        from: purchaseRequestList?.from,
                                        to: purchaseRequestList?.to,
                                        total: purchaseRequestList?.total,
                                    }}
                                    handleFetchData={handleFetchData}
                                    searchPayload={{
                                        isSearched: searchedPurchaseReq.searched,
                                        onClearSearch
                                    }}
                                />
                            </div>

                        </div>
                        {/* Rightbar contents end*/}
                    </div>
                </div>
            </main>
            {/* main body ends */}
            <PurchaseOrderPrint
                name="Purchase Request"
                printDetailView={puchaseReqView}
                newRow={newRow}
                PrintView={componentRef}
            />
        </>
    )
}

export default PurchaseRequestHistory
